import {createSelector} from '@reduxjs/toolkit'

import {RootState} from './interfaces'

export const shoppingSubscriptionSelector = (state: RootState) => state.shoppingSubscription

export const reservedIdSelector = createSelector(shoppingSubscriptionSelector, ({reservedId}) => {
    return reservedId
})
